module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1155.e937a4ef.png";